import React from 'react';
import clsx from 'clsx';
import { VARIANTS } from 'components/_v2/types/themesTypes';
import { THEME_COLORS_BUTTON } from './buttonsStyles';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: VARIANTS;
  addTwStyles?: string;
  disabled?: boolean;
}

function Button({ children, variant = 'primary', disabled, addTwStyles, ...rest }: ButtonProps) {

  return (
    <button
      className={clsx(
        THEME_COLORS_BUTTON[variant].text,
        THEME_COLORS_BUTTON[variant].bg,
        THEME_COLORS_BUTTON[variant].border,
        'font-primary',
        'min-w-[5rem] md:min-w-[7rem]',
        'min-h-[2rem] md:min-h-[2.5rem]',
        'text-xs md:text-md lg:text-base',
        'text-center',
        'overflow-hidden truncate',
        disabled && 'opacity-50',
        addTwStyles,
      )}
      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      type="button"
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;
